import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Box, useHoverable, useFocusable, usePressable, } from "@gemini/core";
export const Tab = ({ label, name, Icon, isActive, onPress }) => {
    const ref = useRef(null);
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocused } = useFocusable(ref);
    const { boxProps: pressProps, isPressed } = usePressable({ onPress });
    const getBackgroundStyles = () => ({
        ...(isActive && {
            backgroundColor: "#AFB5C8",
            color: "#323232", // missing gemini token
        }),
        ...(isHovered &&
            !isActive && {
            backgroundColor: "#3D4459", // missing gemini token
        }),
        ...(isFocused &&
            !isActive && {
            backgroundColor: "#3D4459", // missing gemini token
        }),
        ...(isPressed &&
            !isActive && {
            backgroundColor: "#525A76", // missing gemini token
            outline: "none",
        }),
    });
    return (_jsxs(Box, { as: "button", id: `tab-${name}`, ref: ref, role: "tab", backgroundColor: "#292D3B", display: "flex", alignItems: "center", flexWrap: "nowrap", paddingVertical: "spacing.8", paddingHorizontal: "spacing.16", cursor: "pointer", height: "sizing.40", typography: "typography.body.14.regular", color: "color.background.constant.white", unsafe_style: {
            borderRadius: "2rem",
        }, borderWidth: "borderWidth.none", outlineWidth: isFocused ? "borderWidth.1" : "borderWidth.none", onClick: onPress, "aria-selected": isActive, ...pressProps, ...hoverProps, ...focusProps, ...getBackgroundStyles(), children: [_jsx(Icon, {}), _jsx(Box, { as: "span", marginLeft: "spacing.6", whiteSpace: "nowrap", children: label })] }));
};
